function SuccessPage() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <div
        style={{ width: '600px', padding: '40px', backgroundColor: 'white', marginBottom: '40px' }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            padding: '20px 20px',
            alignItems: 'center',
          }}
        >
          <img src="/logo.png" alt="logo" width={150} />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            gap: '2px',
          }}
        >
          <p
            style={{
              fontWeight: '500',
              wordSpacing: '2px',
              letterSpacing: '1px',
              fontSize: '20px',
              marginBottom: '5px',
            }}
          >
            Mandate failed or not processed
          </p>

          <p style={{ fontSize: '14px', fontWeight: '500', marginTop: '10px' }}></p>
        </div>
      </div>
    </div>
  );
}

export default SuccessPage;
